module.exports = __webpack_public_path__ + "media/images/2024_fanclub_card_basic-acab1aab8ea5a6bf4a55be5b68a67b27.png";